export enum AUTHORITIES {
  ROLE_ADMIN = 'ADMIN',
  ROLE_MANAGER = 'MANAGER',
}
